import React, { useEffect, useState, Fragment } from 'react';
import { Button, Divider, Popover} from 'selfly-ui-react';

import { InputField,AlarmCategories } from '../Selectables';
import MultiSelect from './../multiSelect'
import {DeletePermissionModal} from './../alarmInfoModal'
import SummaryPopOver from './../summaryPopOver.jsx'

const MySettings = ({
    locations,
    saveChanges,
    deleteConfig,
    mySettings
})=>{
    const [confirmationModalOpen,setConfirmationModalOpen] = useState(false)
    const [deletePermission, setDeletePermission] = useState(false)    
    const [alarmSettings,setAlarmSettings] = useState(
        {id:null,  receivers:[], alertTypes:[], isActive:true, locationIds:[]}
    )

    useEffect(()=>{
        if(Object.keys(mySettings).length){
            let settings = {...mySettings}
            settings={...settings, receivers:settings.receivers.map((receiver,index)=>{return {index,value:receiver}})}
            setAlarmSettings(settings)   
        }else{
            setAlarmSettings({id:null,  receivers:[], alertTypes:[], isActive:true, locationIds:[]})
        }
    },[mySettings])

    // Add new input field for receivers
    const addNewInputField = () => {
        const lastIndex = alarmSettings.receivers.length === 0 ? 0 : alarmSettings.receivers[alarmSettings.receivers.length - 1].index;

        setAlarmSettings(prevState => {
            return {
                ...prevState,
                receivers:[...prevState.receivers, { index: lastIndex + 1, value: '' }]
            }
        });
    };

    // when user selectes location
    const onLocationChange =(locationIds)=>{
       
        setAlarmSettings((prevState=>{
            return {...prevState, locationIds}
        }))
    }

    // when user selects alertTypes
    const onAlertTypesChange =(alertTypes)=>{
       
        setAlarmSettings((prevState)=>{
            return {...prevState, alertTypes}
        })
    }

    // when user adds/removes receivers
    const onReceiversChange =(emails)=>{
      
        setAlarmSettings((prevState)=>{
            return {...prevState, receivers:emails}
        })
    }

    useEffect(()=>{
        if(!deletePermission){
            setConfirmationModalOpen(false)
            return
        }
        deleteConfig(alarmSettings.id)
        setConfirmationModalOpen(false)
    },[deletePermission])
  
return (
    <Fragment>
        <div className="settings__item settings__item-gap">
            <DeletePermissionModal 
                confirmationOpen={confirmationModalOpen}
                deleteForever={(permission)=> {
                        setConfirmationModalOpen(false)
                        setDeletePermission(permission)
                    }
                }
                message='Deleting will remove all your alarm settings and you no longer will be able to receive any email notifications when any incidents occour in your cabinets.'
            />       
            <div className="settings__item-label">Select cabinet locations</div>
            <MultiSelect 
                locations={locations}
                selectedLocations={alarmSettings.locationIds} 
                locationChange={(locationArray)=> {onLocationChange(locationArray)}}
            />
            <AlarmCategories
                alertTypes={alarmSettings.alertTypes}
                updateAlertTypes = {(types)=>{onAlertTypesChange(types)}}
                configId={alarmSettings.id}
            />
            {alarmSettings.receivers.length ===0 && <div className="settings__item-label">Please add emails to subscribe for alarm notifcations</div>}
            {alarmSettings.receivers.length >0 && <div className="settings__item-label">Add email address of alarm receivers</div>}
            <div className="scrollable">
                <InputField inputs={alarmSettings.receivers} inputUpdated={ updatedReceivers => { onReceiversChange(updatedReceivers)}} />
            </div>           
            <div className="settings__item">
                <div className="settings__item-config">
                    <div className="settings__button-group">
                        <Button 
                            icon="add"
                            onClick={()=>{addNewInputField()}}
                        >
                            Add
                        </Button>
                    </div>
                </div>
            </div>                    
        </div>
        <div className="settings__item">
            <div className="settings__item-config">                                
                <Divider/>
                <div className="settings__button-group">
                    <div className="settings__button-popover">
                            <Popover
                                component={
                                            <Button className="settings__button-list" icon="list">Summary</Button>
                                        }
                                position="top"
                                className="summary__popover"
                                isFlipping={true}
                            >
                                {
                                    <SummaryPopOver
                                        alertTypes={alarmSettings.alertTypes}
                                        alarmReceivers={alarmSettings.receivers}
                                        locations={locations}
                                        selectedLocations={alarmSettings.locationIds}
                                    />
                                }
                            </Popover>     
                        <Button
                            icon="save"
                            type="positive"
                            onClick={() => {
                                saveChanges(alarmSettings)
                            }}
                            disabled={!alarmSettings.alertTypes.length}
                        >
                            Save changes
                            
                        </Button>
                    </div>
                    <Button
                        icon="delete_forever"
                        type="negative"
                        disabled={!alarmSettings.id}
                        onClick={() => {
                            setConfirmationModalOpen(true);
                        }}                                      
                    >
                        Delete
                    </Button>                                        
                </div>
            </div>
        </div>
    </Fragment>
)}
export default MySettings